import React from "react";
import FeatureCategory from "../../featurecategory";
import SEO from "../../seo";

export default function TemperatureRegulationPage() {
  const categoryName = "Temperature Regulation";

  const products = [
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Tiara-Cool-1.png",
      name: "Tiara Cool",
      link: "/patent-series-mattress/tiara-cool/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2020/01/Outlast.png",
      name: "Outlast",
      link: "/harmony-collection/outlast/",
    },

    {
      img: "https://eclipsemattress.in/wp-content/uploads/2020/01/Ortho-visco_PNG.png",
      name: "Ortho Visco LX",
      link: "/luxury-collection/ortho-visco-lx/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2021/06/1000X667-cover-1.png",
      name: "ORTHO Latex LX",
      link: "/luxury-collection/ortho-latex-lx/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Posture-comfort-PT.png",
      name: "Posture Comfort",
      link: "/luxury-collection/posture-comfort/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2021/06/1000X667-2.png",
      name: "Posture Care",
      link: "/luxury-collection/posture-care/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Posture-Therapy-PT-1.png",
      name: "Posture Therapy",
      link: "/luxury-collection/posture-therapy/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Posture-Therapy-PT-1.png",
      name: "Ortho Visco",
      link: "/visco-mattress/ortho-visco/",
    },
    {
      img: "https://eclipsemattress.in/assets/images/products/natura-latex/Natura-Latex-02.png",
      name: "NATURA LATEX",
      link: "/latex-mattress/natura-latex/",
    },
    {
      img: "https://eclipsemattress.in/assets/images/products/portofino-latex/Portofino-Latex-02.png",
      name: "Portofino Latex",
      link: "/latex-mattress/portofino-latex/",
    },
  ];

  const categoryDescription = "<br/>";
  return (
    <div>
      <SEO
        title="Temperature Regulation | Eclipse International"
        description=""
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-main.jpg"
      />
      <FeatureCategory
        products={products}
        categoryName={categoryName}
        categoryDescription={categoryDescription}
      />
    </div>
  );
}
